import { render } from "./GreenifiedCheckbox.vue?vue&type=template&id=30462990&scoped=true"
import script from "./GreenifiedCheckbox.vue?vue&type=script&lang=js"
export * from "./GreenifiedCheckbox.vue?vue&type=script&lang=js"

import "./GreenifiedCheckbox.vue?vue&type=style&index=0&id=30462990&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30462990"]])

export default __exports__